import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { translate } from "../../../base/i18n";
import MessageContainer from "../MessageContainer";

function ChatBody({
    t, messages
}) {
    const messageContainerRef = useRef();

    const _scrollMessageContainerToBottom = withAnimation => {
        if (messageContainerRef.current) {
            messageContainerRef.current.scrollToBottom(withAnimation);
        }
    };

    useEffect(() => {
        _scrollMessageContainerToBottom(true);
    }, [messages]);

    return (
        <ChatBodyStyled>
            <MessageContainer t={t} ref={messageContainerRef} messages={messages} />
        </ChatBodyStyled>
    )
}

const ChatBodyStyled = styled.div`
    width: 100%;
    flex: 1;
    overflow: auto; 
    box-sizing: border-box;
    background: #fff;

    .message {
        box-sizing: border-box;
        padding: 4px 8px;
        white-space: pre;

        .sender { font-size: 12px; }

        &_true > .sender { color #e60000; }
        &_false > .sender { color #123; }

        &.text {
            .message_context {
                display: inline-flex;
                align-items: flex-end;

                .time {
                    margin: 6px;
                    position: relative;
                    top: 4px;
                    font-size: 10px;
                    color: #a5a5a5;
                }
                .message {
                    padding: 5px 10px 6px;
                    border-radius: 10px;
                    display: inline-block;
                    margin-top: 5px;
                    max-width: 90%;
                    white-space: pre-wrap;
                    word-break: break-all;
                } 
            } 

            &.local {
                text-align: right;
                
                .sender {
                    text-align: right;
                }
                .message_context {
                    .message {
                        background: #0d8fdf;
                        color: white;
                        text-align: left;
                    }                            
                }
            }
            
            &.remote {
                text-align: left;
                .message_context {
                    flex-direction: row-reverse;
                    
                    .message {
                        background: #f2f2f2;
                        color: black;   
                        text-align: left;
                    }
                                 
                }                        
            }  
        }

        &.file {
            .message_context {
                overflow: hidden;
                text-overflow: ellipsis;
            }
            
            &.message_false > .sender {
                color: #fff;
            } 

            width: 100%;
            padding: 8px; margin: 1px 0;
            background: #123;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;                    

            .message_text {
                width: 80%; margin-left: 0;                       

                .sender {
                    font-size: 13px;
                    margin-bottom: 5px;
                }
            }

            .message_file{
                float: right;
                cursor: pointer;
                right: 15px;
                display: inline-flex;
                flex-direction: column;
                margin: 0;

                .message_download {
                    width: 26px; height: 22px; 
                    margin-bottom: 5px;
                    background-position: -428px -210px; 
                }
            }
            
        }
    }
`;

export default translate(ChatBody);